import { Loading } from '@components/Loading'
import { ReactElement, useEffect } from 'react'

import { useStep } from '@/hooks/useStep'
import { useWebsocket } from '@/hooks/useWebsocket'
import { WebSocketState } from '@/types/websocket'

export const WebsocketWrapper = ({ children }: { children: ReactElement }) => {
  const { connect, websocketState, disconnect } = useWebsocket()
  const { setCurrentStep } = useStep()

  useEffect(() => {
    connect()
    setCurrentStep((prev) => (prev ? { ...prev, backButton: undefined } : undefined)) // Remove back button

    return () => {
      disconnect()
    }
  }, [])

  return (
    <>
      {websocketState !== WebSocketState.OPEN && <Loading />}
      {children}
    </>
  )
}
